import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CompanyAdditionalIncome } from '@app/models/payroll/company-additional-income.model';
import { JurisdictionToggle } from '@app/models/payroll/jurisdiction-toggle.model';
import { Province } from '@app/types/province';
import { TranslatableKey } from '@app/types/translatable.type';

interface Taxation {
    name: TranslatableKey;
    property: boolean | null;
}

@Component({
    selector: 'app-additional-income-taxation',
    templateUrl: './additional-income-taxation.template.html',
    styleUrls: ['./additional-income-taxation.style.scss'],
})
export class AdditionalIncomeTaxation implements OnChanges {
    @Input() companyAdditionalIncome: CompanyAdditionalIncome | null = null;
    @Input() selectedProvince: Province = 'ON';
    taxations: Taxation[] = this.generateTaxations();

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.companyAdditionalIncome?.previousValue !== this.companyAdditionalIncome ||
            changes.selectedProvince?.previousValue !== this.selectedProvince
        ) {
            this.taxations = this.generateTaxations();
        }
    }

    private getJurisdictionToggle(): JurisdictionToggle | undefined {
        return this.companyAdditionalIncome?.jurisdictionToggles?.find(
            (toggle) => toggle.jurisdiction === this.selectedProvince
        );
    }

    private generateTaxations(): Taxation[] {
        const jurisdictionToggle = this.getJurisdictionToggle();

        return [
            {
                name: 'payroll.additionalIncomeTaxation.incomeTax',
                property: jurisdictionToggle?.taxable ?? this.companyAdditionalIncome?.taxable ?? null,
            },
            {
                name: 'payroll.additionalIncomeTaxation.cpp',
                property: jurisdictionToggle?.pensionable ?? this.companyAdditionalIncome?.pensionable ?? null,
            },
            {
                name: 'payroll.additionalIncomeTaxation.ei',
                property: jurisdictionToggle?.insurable ?? this.companyAdditionalIncome?.insurable ?? null,
            },
            {
                name: 'payroll.additionalIncomeTaxation.ept',
                property: jurisdictionToggle?.eptable ?? this.companyAdditionalIncome?.eptable ?? null,
            },
            {
                name: 'payroll.additionalIncomeTaxation.wcb',
                property: this.companyAdditionalIncome?.assessable ?? null,
            },
            {
                name: 'payroll.additionalIncomeTaxation.lumpSum',
                property: jurisdictionToggle?.lumpSummable ?? this.companyAdditionalIncome?.lumpSummable ?? null,
            },
        ];
    }
}
